module.exports = __webpack_public_path__ + "static/media/Pizza Costume.d2cea632.jpg";